import apolloClient from 'apollo-client'
import {
  GET_DRAFT_ORDERS,
  DELETE_DRAFT_ORDER,
  APPLY_DISCOUNT_CODE,
  CREATE_SHIPPING_RATE,
  COMPLETE_DRAFT_ORDER,
  APPLY_WINE_CLUB_DISCOUNT,
  UPDATE_DRAFT_ORDER_PAYMENT_METHOD,
  VALIDATE_DRAFT_ORDER_DISCOUNT,
  REMOVE_DRAFT_ORDER_DISCOUNTS,
  COMPLETE_DRAFT_ORDER_WITH_CASH_AND_CHEQUE,
} from './graphql'
import {
  GET_DRAFT_ORDER,
  REMOVE_DRAFT_ORDER_DISCOUNT,
  UPDATE_DRAFT_ORDER,
} from 'app/features/orders/graphql'
import {getTimezone} from 'app/utilities'
class DraftOrderService {
  async getDraftOrder(params: any) {
    const newState: any = {...params}
    newState.filter.deletedAt = {isNull: true}
    const {data} = await apolloClient.query({
      query: GET_DRAFT_ORDERS,
      variables: newState,
    })
    return {data: data.draftOrders.nodes, totalCount: data.draftOrders.totalCount}
  }

  async deleteDraftOrder(orderId: any) {
    return await apolloClient.mutate({
      mutation: DELETE_DRAFT_ORDER,
      variables: orderId,
    })
  }

  async applyDiscountCode(discount: any) {
    discount.timezone = getTimezone()
    const {data} = await apolloClient.mutate({
      mutation: APPLY_DISCOUNT_CODE,
      variables: {discount},
    })
    const {draftOrderDiscountCodeApply} = data
    return draftOrderDiscountCodeApply
  }

  async validateDiscount(discount: any) {
    discount.timezone = getTimezone()
    const {data} = await apolloClient.mutate({
      mutation: VALIDATE_DRAFT_ORDER_DISCOUNT,
      variables: {discount},
    })
    const {draftOrderValidateDiscount} = data
    return draftOrderValidateDiscount
  }

  async removeDraftOrderDiscounts(discount: any) {
    return await apolloClient.mutate({
      mutation: REMOVE_DRAFT_ORDER_DISCOUNTS,
      variables: {discount},
    })
  }

  async applyWineClubDiscountCode(discount: any) {
    discount.timezone = getTimezone()
    const {data} = await apolloClient.mutate({
      mutation: APPLY_WINE_CLUB_DISCOUNT,
      variables: {discount},
    })
    const {draftOrderWineClubDiscountApply} = data
    return draftOrderWineClubDiscountApply
  }

  async updateDraftOrderPaymentBillingMethod(draftOrder: any) {
    return await apolloClient.mutate({
      mutation: UPDATE_DRAFT_ORDER_PAYMENT_METHOD,
      variables: draftOrder,
    })
  }

  async createShippingRate(draftOrder: any) {
    const {data} = await apolloClient.mutate({
      mutation: CREATE_SHIPPING_RATE,
      variables: {
        draftOrder,
      },
    })
    const {updateDraftOrder} = data
    const shippingRate = draftOrder.patch.shippingRate.create
    shippingRate.id = updateDraftOrder.shippingRate.id
    return shippingRate
  }

  async updateDraftOrder(draftOrder: any, id: any) {
    await apolloClient.mutate({
      mutation: UPDATE_DRAFT_ORDER,
      variables: {draftOrder, id},
    })
  }

  async removeDraftOrderDiscount(discountCodeId: string, id: any) {
    const {errors} = await apolloClient.mutate({
      mutation: REMOVE_DRAFT_ORDER_DISCOUNT,
      variables: {discountCodeId, id},
    })
    if (errors) {
      throw errors
    }
  }

  fetchDraftOrder = async (id: string) => {
    const {data} = await apolloClient.query({
      query: GET_DRAFT_ORDER,
      variables: {id},
    })
    return data.draftOrder
  }

  async completeDraftOrder(draftOrder: any) {
    const {data, errors} = await apolloClient.mutate({
      mutation: COMPLETE_DRAFT_ORDER,
      variables: {
        draftOrder,
      },
    })
    if (errors) {
      throw errors
    }
    return data.draftOrderComplete
  }

  async completeDraftOrderWithCashAndCheque(draftOrder: any) {
    const {data, errors} = await apolloClient.mutate({
      mutation: COMPLETE_DRAFT_ORDER_WITH_CASH_AND_CHEQUE,
      variables: {
        draftOrder,
      },
    })
    if (errors) {
      throw errors
    }
    return data.draftOrderCompleteWithCashAndCheque
  }
}

const draftOrderService = new DraftOrderService()
export default draftOrderService
